module.exports = __webpack_public_path__ + "img/performance_settings.5ec89c7f.png";